export const timezones = [
  {
    name: "Pacific/Niue",
    offset: "GMT-11",
  },
  {
    name: "Pacific/Midway",
    offset: "GMT-11",
  },
  {
    name: "Pacific/Pago_Pago",
    offset: "GMT-11",
  },
  {
    name: "Pacific/Rarotonga",
    offset: "GMT-10",
  },
  {
    name: "America/Adak",
    offset: "GMT-10",
  },
  {
    name: "Pacific/Honolulu",
    offset: "GMT-10",
  },
  {
    name: "Pacific/Tahiti",
    offset: "GMT-10",
  },
  {
    name: "Pacific/Marquesas",
    offset: "GMT-9.5",
  },
  {
    name: "America/Anchorage",
    offset: "GMT-9",
  },
  {
    name: "Pacific/Gambier",
    offset: "GMT-9",
  },
  {
    name: "America/Los_Angeles",
    offset: "GMT-8",
  },
  {
    name: "America/Tijuana",
    offset: "GMT-8",
  },
  {
    name: "America/Vancouver",
    offset: "GMT-8",
  },
  {
    name: "America/Whitehorse",
    offset: "GMT-7",
  },
  {
    name: "Pacific/Pitcairn",
    offset: "GMT-8",
  },
  {
    name: "America/Hermosillo",
    offset: "GMT-7",
  },
  {
    name: "America/Edmonton",
    offset: "GMT-7",
  },
  {
    name: "America/Ojinaga",
    offset: "GMT-7",
  },
  {
    name: "America/Denver",
    offset: "GMT-7",
  },
  {
    name: "America/Dawson_Creek",
    offset: "GMT-7",
  },
  {
    name: "America/Phoenix",
    offset: "GMT-7",
  },
  {
    name: "America/Belize",
    offset: "GMT-6",
  },
  {
    name: "America/Chicago",
    offset: "GMT-6",
  },
  {
    name: "America/Guatemala",
    offset: "GMT-6",
  },
  {
    name: "America/Managua",
    offset: "GMT-6",
  },
  {
    name: "America/Mexico_City",
    offset: "GMT-6",
  },
  {
    name: "America/Costa_Rica",
    offset: "GMT-6",
  },
  {
    name: "America/El_Salvador",
    offset: "GMT-6",
  },
  {
    name: "America/Regina",
    offset: "GMT-6",
  },
  {
    name: "America/Tegucigalpa",
    offset: "GMT-6",
  },
  {
    name: "America/Winnipeg",
    offset: "GMT-6",
  },
  {
    name: "Pacific/Galapagos",
    offset: "GMT-6",
  },
  {
    name: "America/Rio_Branco",
    offset: "GMT-5",
  },
  {
    name: "America/Bogota",
    offset: "GMT-5",
  },
  {
    name: "America/Havana",
    offset: "GMT-5",
  },
  {
    name: "Pacific/Easter",
    offset: "GMT-6",
  },
  {
    name: "America/Atikokan",
    offset: "GMT-5",
  },
  {
    name: "America/Cancun",
    offset: "GMT-5",
  },
  {
    name: "America/Grand_Turk",
    offset: "GMT-5",
  },
  {
    name: "America/Cayman",
    offset: "GMT-5",
  },
  {
    name: "America/Jamaica",
    offset: "GMT-5",
  },
  {
    name: "America/Nassau",
    offset: "GMT-5",
  },
  {
    name: "America/New_York",
    offset: "GMT-5",
  },
  {
    name: "America/Panama",
    offset: "GMT-5",
  },
  {
    name: "America/Port-au-Prince",
    offset: "GMT-5",
  },
  {
    name: "America/Toronto",
    offset: "GMT-5",
  },
  {
    name: "America/Guayaquil",
    offset: "GMT-5",
  },
  {
    name: "America/Lima",
    offset: "GMT-5",
  },
  {
    name: "America/Manaus",
    offset: "GMT-4",
  },
  {
    name: "America/St_Kitts",
    offset: "GMT-4",
  },
  {
    name: "America/Montserrat",
    offset: "GMT-4",
  },
  {
    name: "America/Barbados",
    offset: "GMT-4",
  },
  {
    name: "America/St_Lucia",
    offset: "GMT-4",
  },
  {
    name: "America/Port_of_Spain",
    offset: "GMT-4",
  },
  {
    name: "America/Martinique",
    offset: "GMT-4",
  },
  {
    name: "America/St_Barthelemy",
    offset: "GMT-4",
  },
  {
    name: "America/Halifax",
    offset: "GMT-4",
  },
  {
    name: "Atlantic/Bermuda",
    offset: "GMT-4",
  },
  {
    name: "America/St_Vincent",
    offset: "GMT-4",
  },
  {
    name: "America/Kralendijk",
    offset: "GMT-4",
  },
  {
    name: "America/Guadeloupe",
    offset: "GMT-4",
  },
  {
    name: "America/Blanc-Sablon",
    offset: "GMT-4",
  },
  {
    name: "America/Marigot",
    offset: "GMT-4",
  },
  {
    name: "America/Aruba",
    offset: "GMT-4",
  },
  {
    name: "America/Lower_Princes",
    offset: "GMT-4",
  },
  {
    name: "America/Tortola",
    offset: "GMT-4",
  },
  {
    name: "America/Dominica",
    offset: "GMT-4",
  },
  {
    name: "America/St_Thomas",
    offset: "GMT-4",
  },
  {
    name: "America/Grenada",
    offset: "GMT-4",
  },
  {
    name: "America/Antigua",
    offset: "GMT-4",
  },
  {
    name: "America/Puerto_Rico",
    offset: "GMT-4",
  },
  {
    name: "America/Santo_Domingo",
    offset: "GMT-4",
  },
  {
    name: "America/Anguilla",
    offset: "GMT-4",
  },
  {
    name: "America/Thule",
    offset: "GMT-4",
  },
  {
    name: "America/Curacao",
    offset: "GMT-4",
  },
  {
    name: "America/La_Paz",
    offset: "GMT-4",
  },
  {
    name: "America/Guyana",
    offset: "GMT-4",
  },
  {
    name: "America/Caracas",
    offset: "GMT-4",
  },
  {
    name: "America/St_Johns",
    offset: "GMT-3.5",
  },
  {
    name: "America/Argentina/Buenos_Aires",
    offset: "GMT-3",
  },
  {
    name: "America/Sao_Paulo",
    offset: "GMT-3",
  },
  {
    name: "America/Santiago",
    offset: "GMT-4",
  },
  {
    name: "Antarctica/Palmer",
    offset: "GMT-3",
  },
  {
    name: "America/Punta_Arenas",
    offset: "GMT-3",
  },
  {
    name: "Atlantic/Stanley",
    offset: "GMT-3",
  },
  {
    name: "America/Cayenne",
    offset: "GMT-3",
  },
  {
    name: "America/Asuncion",
    offset: "GMT-4",
  },
  {
    name: "America/Miquelon",
    offset: "GMT-3",
  },
  {
    name: "America/Paramaribo",
    offset: "GMT-3",
  },
  {
    name: "America/Montevideo",
    offset: "GMT-3",
  },
  {
    name: "America/Godthab",
    offset: "GMT-3",
  },
  {
    name: "America/Noronha",
    offset: "GMT-2",
  },
  {
    name: "Atlantic/South_Georgia",
    offset: "GMT-2",
  },
  {
    name: "Atlantic/Azores",
    offset: "GMT-1",
  },
  {
    name: "Atlantic/Cape_Verde",
    offset: "GMT-1",
  },
  {
    name: "America/Scoresbysund",
    offset: "GMT-1",
  },
  {
    name: "UTC",
    offset: "GMT+0",
  },
  {
    name: "Africa/Abidjan",
    offset: "GMT+0",
  },
  {
    name: "Africa/Accra",
    offset: "GMT+0",
  },
  {
    name: "Africa/Bamako",
    offset: "GMT+0",
  },
  {
    name: "Africa/Bissau",
    offset: "GMT+0",
  },
  {
    name: "Africa/Conakry",
    offset: "GMT+0",
  },
  {
    name: "Africa/Dakar",
    offset: "GMT+0",
  },
  {
    name: "America/Danmarkshavn",
    offset: "GMT+0",
  },
  {
    name: "Europe/Isle_of_Man",
    offset: "GMT+0",
  },
  {
    name: "Europe/Dublin",
    offset: "GMT+0",
  },
  {
    name: "Africa/Freetown",
    offset: "GMT+0",
  },
  {
    name: "Atlantic/St_Helena",
    offset: "GMT+0",
  },
  {
    name: "Africa/Lome",
    offset: "GMT+0",
  },
  {
    name: "Europe/London",
    offset: "GMT+0",
  },
  {
    name: "Africa/Monrovia",
    offset: "GMT+0",
  },
  {
    name: "Africa/Nouakchott",
    offset: "GMT+0",
  },
  {
    name: "Africa/Ouagadougou",
    offset: "GMT+0",
  },
  {
    name: "Atlantic/Reykjavik",
    offset: "GMT+0",
  },
  {
    name: "Europe/Jersey",
    offset: "GMT+0",
  },
  {
    name: "Europe/Guernsey",
    offset: "GMT+0",
  },
  {
    name: "Africa/Banjul",
    offset: "GMT+0",
  },
  {
    name: "Africa/Sao_Tome",
    offset: "GMT+0",
  },
  {
    name: "Antarctica/Troll",
    offset: "GMT+0",
  },
  {
    name: "Atlantic/Canary",
    offset: "GMT+0",
  },
  {
    name: "Europe/Lisbon",
    offset: "GMT+0",
  },
  {
    name: "Atlantic/Faroe",
    offset: "GMT+0",
  },
  {
    name: "Africa/Algiers",
    offset: "GMT+1",
  },
  {
    name: "Europe/Amsterdam",
    offset: "GMT+1",
  },
  {
    name: "Europe/Andorra",
    offset: "GMT+1",
  },
  {
    name: "Europe/Belgrade",
    offset: "GMT+1",
  },
  {
    name: "Europe/Berlin",
    offset: "GMT+1",
  },
  {
    name: "Europe/Malta",
    offset: "GMT+1",
  },
  {
    name: "Europe/Bratislava",
    offset: "GMT+1",
  },
  {
    name: "Europe/Brussels",
    offset: "GMT+1",
  },
  {
    name: "Europe/Budapest",
    offset: "GMT+1",
  },
  {
    name: "Europe/Copenhagen",
    offset: "GMT+1",
  },
  {
    name: "Europe/Gibraltar",
    offset: "GMT+1",
  },
  {
    name: "Europe/Ljubljana",
    offset: "GMT+1",
  },
  {
    name: "Arctic/Longyearbyen",
    offset: "GMT+1",
  },
  {
    name: "Europe/Luxembourg",
    offset: "GMT+1",
  },
  {
    name: "Europe/Madrid",
    offset: "GMT+1",
  },
  {
    name: "Europe/Monaco",
    offset: "GMT+1",
  },
  {
    name: "Europe/Oslo",
    offset: "GMT+1",
  },
  {
    name: "Europe/Paris",
    offset: "GMT+1",
  },
  {
    name: "Europe/Podgorica",
    offset: "GMT+1",
  },
  {
    name: "Europe/Prague",
    offset: "GMT+1",
  },
  {
    name: "Europe/Rome",
    offset: "GMT+1",
  },
  {
    name: "Europe/San_Marino",
    offset: "GMT+1",
  },
  {
    name: "Europe/Sarajevo",
    offset: "GMT+1",
  },
  {
    name: "Europe/Skopje",
    offset: "GMT+1",
  },
  {
    name: "Europe/Stockholm",
    offset: "GMT+1",
  },
  {
    name: "Europe/Tirane",
    offset: "GMT+1",
  },
  {
    name: "Africa/Tunis",
    offset: "GMT+1",
  },
  {
    name: "Europe/Vaduz",
    offset: "GMT+1",
  },
  {
    name: "Europe/Vatican",
    offset: "GMT+1",
  },
  {
    name: "Europe/Vienna",
    offset: "GMT+1",
  },
  {
    name: "Europe/Warsaw",
    offset: "GMT+1",
  },
  {
    name: "Europe/Zagreb",
    offset: "GMT+1",
  },
  {
    name: "Europe/Zurich",
    offset: "GMT+1",
  },
  {
    name: "Africa/Bangui",
    offset: "GMT+1",
  },
  {
    name: "Africa/Malabo",
    offset: "GMT+1",
  },
  {
    name: "Africa/Brazzaville",
    offset: "GMT+1",
  },
  {
    name: "Africa/Porto-Novo",
    offset: "GMT+1",
  },
  {
    name: "Africa/Douala",
    offset: "GMT+1",
  },
  {
    name: "Africa/Kinshasa",
    offset: "GMT+1",
  },
  {
    name: "Africa/Lagos",
    offset: "GMT+1",
  },
  {
    name: "Africa/Libreville",
    offset: "GMT+1",
  },
  {
    name: "Africa/Luanda",
    offset: "GMT+1",
  },
  {
    name: "Africa/Ndjamena",
    offset: "GMT+1",
  },
  {
    name: "Africa/Niamey",
    offset: "GMT+1",
  },
  {
    name: "Africa/Casablanca",
    offset: "GMT+0",
  },
  {
    name: "Africa/El_Aaiun",
    offset: "GMT+0",
  },
  {
    name: "Africa/Windhoek",
    offset: "GMT+1",
  },
  {
    name: "Africa/Bujumbura",
    offset: "GMT+2",
  },
  {
    name: "Africa/Gaborone",
    offset: "GMT+2",
  },
  {
    name: "Africa/Harare",
    offset: "GMT+2",
  },
  {
    name: "Africa/Khartoum",
    offset: "GMT+2",
  },
  {
    name: "Africa/Kigali",
    offset: "GMT+2",
  },
  {
    name: "Africa/Blantyre",
    offset: "GMT+2",
  },
  {
    name: "Africa/Lubumbashi",
    offset: "GMT+2",
  },
  {
    name: "Africa/Lusaka",
    offset: "GMT+2",
  },
  {
    name: "Africa/Maputo",
    offset: "GMT+2",
  },
  {
    name: "Asia/Damascus",
    offset: "GMT+2",
  },
  {
    name: "Asia/Amman",
    offset: "GMT+2",
  },
  {
    name: "Europe/Athens",
    offset: "GMT+2",
  },
  {
    name: "Asia/Beirut",
    offset: "GMT+2",
  },
  {
    name: "Europe/Bucharest",
    offset: "GMT+2",
  },
  {
    name: "Africa/Cairo",
    offset: "GMT+2",
  },
  {
    name: "Europe/Chisinau",
    offset: "GMT+2",
  },
  {
    name: "Asia/Hebron",
    offset: "GMT+2",
  },
  {
    name: "Europe/Helsinki",
    offset: "GMT+2",
  },
  {
    name: "Europe/Kaliningrad",
    offset: "GMT+2",
  },
  {
    name: "Europe/Kiev",
    offset: "GMT+2",
  },
  {
    name: "Europe/Mariehamn",
    offset: "GMT+2",
  },
  {
    name: "Asia/Nicosia",
    offset: "GMT+2",
  },
  {
    name: "Europe/Riga",
    offset: "GMT+2",
  },
  {
    name: "Europe/Sofia",
    offset: "GMT+2",
  },
  {
    name: "Europe/Tallinn",
    offset: "GMT+2",
  },
  {
    name: "Africa/Tripoli",
    offset: "GMT+2",
  },
  {
    name: "Europe/Vilnius",
    offset: "GMT+2",
  },
  {
    name: "Asia/Jerusalem",
    offset: "GMT+2",
  },
  {
    name: "Africa/Johannesburg",
    offset: "GMT+2",
  },
  {
    name: "Africa/Mbabane",
    offset: "GMT+2",
  },
  {
    name: "Africa/Maseru",
    offset: "GMT+2",
  },
  {
    name: "Asia/Kuwait",
    offset: "GMT+3",
  },
  {
    name: "Asia/Baghdad",
    offset: "GMT+3",
  },
  {
    name: "Asia/Qatar",
    offset: "GMT+3",
  },
  {
    name: "Asia/Bahrain",
    offset: "GMT+3",
  },
  {
    name: "Asia/Riyadh",
    offset: "GMT+3",
  },
  {
    name: "Asia/Aden",
    offset: "GMT+3",
  },
  {
    name: "Africa/Addis_Ababa",
    offset: "GMT+3",
  },
  {
    name: "Indian/Antananarivo",
    offset: "GMT+3",
  },
  {
    name: "Africa/Asmara",
    offset: "GMT+3",
  },
  {
    name: "Africa/Dar_es_Salaam",
    offset: "GMT+3",
  },
  {
    name: "Africa/Djibouti",
    offset: "GMT+3",
  },
  {
    name: "Africa/Juba",
    offset: "GMT+3",
  },
  {
    name: "Africa/Kampala",
    offset: "GMT+3",
  },
  {
    name: "Indian/Mayotte",
    offset: "GMT+3",
  },
  {
    name: "Africa/Mogadishu",
    offset: "GMT+3",
  },
  {
    name: "Indian/Comoro",
    offset: "GMT+3",
  },
  {
    name: "Africa/Nairobi",
    offset: "GMT+3",
  },
  {
    name: "Europe/Minsk",
    offset: "GMT+3",
  },
  {
    name: "Europe/Moscow",
    offset: "GMT+3",
  },
  {
    name: "Antarctica/Syowa",
    offset: "GMT+3",
  },
  {
    name: "Europe/Istanbul",
    offset: "GMT+3",
  },
  {
    name: "Asia/Tehran",
    offset: "GMT+3.5",
  },
  {
    name: "Asia/Yerevan",
    offset: "GMT+4",
  },
  {
    name: "Asia/Baku",
    offset: "GMT+4",
  },
  {
    name: "Asia/Tbilisi",
    offset: "GMT+4",
  },
  {
    name: "Asia/Dubai",
    offset: "GMT+4",
  },
  {
    name: "Asia/Muscat",
    offset: "GMT+4",
  },
  {
    name: "Indian/Mauritius",
    offset: "GMT+4",
  },
  {
    name: "Indian/Reunion",
    offset: "GMT+4",
  },
  {
    name: "Europe/Samara",
    offset: "GMT+4",
  },
  {
    name: "Indian/Mahe",
    offset: "GMT+4",
  },
  {
    name: "Asia/Kabul",
    offset: "GMT+4.5",
  },
  {
    name: "Indian/Kerguelen",
    offset: "GMT+5",
  },
  {
    name: "Indian/Maldives",
    offset: "GMT+5",
  },
  {
    name: "Antarctica/Mawson",
    offset: "GMT+5",
  },
  {
    name: "Asia/Karachi",
    offset: "GMT+5",
  },
  {
    name: "Asia/Dushanbe",
    offset: "GMT+5",
  },
  {
    name: "Asia/Ashgabat",
    offset: "GMT+5",
  },
  {
    name: "Asia/Tashkent",
    offset: "GMT+5",
  },
  {
    name: "Asia/Qyzylorda",
    offset: "GMT+5",
  },
  {
    name: "Asia/Yekaterinburg",
    offset: "GMT+5",
  },
  {
    name: "Asia/Colombo",
    offset: "GMT+5.5",
  },
  {
    name: "Asia/Kolkata",
    offset: "GMT+5.5",
  },
  {
    name: "Asia/Kathmandu",
    offset: "GMT+5.75",
  },
  {
    name: "Asia/Dhaka",
    offset: "GMT+6",
  },
  {
    name: "Asia/Thimphu",
    offset: "GMT+6",
  },
  {
    name: "Asia/Urumqi",
    offset: "GMT+6",
  },
  {
    name: "Asia/Almaty",
    offset: "GMT+6",
  },
  {
    name: "Indian/Chagos",
    offset: "GMT+6",
  },
  {
    name: "Asia/Bishkek",
    offset: "GMT+6",
  },
  {
    name: "Asia/Omsk",
    offset: "GMT+6",
  },
  {
    name: "Antarctica/Vostok",
    offset: "GMT+6",
  },
  {
    name: "Indian/Cocos",
    offset: "GMT+6.5",
  },
  {
    name: "Asia/Yangon",
    offset: "GMT+6.5",
  },
  {
    name: "Indian/Christmas",
    offset: "GMT+7",
  },
  {
    name: "Antarctica/Davis",
    offset: "GMT+7",
  },
  {
    name: "Asia/Hovd",
    offset: "GMT+7",
  },
  {
    name: "Asia/Bangkok",
    offset: "GMT+7",
  },
  {
    name: "Asia/Ho_Chi_Minh",
    offset: "GMT+7",
  },
  {
    name: "Asia/Phnom_Penh",
    offset: "GMT+7",
  },
  {
    name: "Asia/Vientiane",
    offset: "GMT+7",
  },
  {
    name: "Asia/Novosibirsk",
    offset: "GMT+7",
  },
  {
    name: "Asia/Jakarta",
    offset: "GMT+7",
  },
  {
    name: "Australia/Perth",
    offset: "GMT+8",
  },
  {
    name: "Antarctica/Casey",
    offset: "GMT+11",
  },
  {
    name: "Asia/Brunei",
    offset: "GMT+8",
  },
  {
    name: "Asia/Makassar",
    offset: "GMT+8",
  },
  {
    name: "Asia/Macau",
    offset: "GMT+8",
  },
  {
    name: "Asia/Shanghai",
    offset: "GMT+8",
  },
  {
    name: "Asia/Hong_Kong",
    offset: "GMT+8",
  },
  {
    name: "Asia/Irkutsk",
    offset: "GMT+8",
  },
  {
    name: "Asia/Kuala_Lumpur",
    offset: "GMT+8",
  },
  {
    name: "Asia/Manila",
    offset: "GMT+8",
  },
  {
    name: "Asia/Singapore",
    offset: "GMT+8",
  },
  {
    name: "Asia/Taipei",
    offset: "GMT+8",
  },
  {
    name: "Asia/Ulaanbaatar",
    offset: "GMT+8",
  },
  {
    name: "Australia/Eucla",
    offset: "GMT+8.75",
  },
  {
    name: "Asia/Dili",
    offset: "GMT+9",
  },
  {
    name: "Asia/Jayapura",
    offset: "GMT+9",
  },
  {
    name: "Asia/Tokyo",
    offset: "GMT+9",
  },
  {
    name: "Asia/Pyongyang",
    offset: "GMT+9",
  },
  {
    name: "Asia/Seoul",
    offset: "GMT+9",
  },
  {
    name: "Pacific/Palau",
    offset: "GMT+9",
  },
  {
    name: "Asia/Chita",
    offset: "GMT+9",
  },
  {
    name: "Australia/Darwin",
    offset: "GMT+9.5",
  },
  {
    name: "Australia/Brisbane",
    offset: "GMT+10",
  },
  {
    name: "Pacific/Guam",
    offset: "GMT+10",
  },
  {
    name: "Pacific/Saipan",
    offset: "GMT+10",
  },
  {
    name: "Pacific/Chuuk",
    offset: "GMT+10",
  },
  {
    name: "Antarctica/DumontDUrville",
    offset: "GMT+10",
  },
  {
    name: "Pacific/Port_Moresby",
    offset: "GMT+10",
  },
  {
    name: "Asia/Vladivostok",
    offset: "GMT+10",
  },
  {
    name: "Australia/Adelaide",
    offset: "GMT+9.5",
  },
  {
    name: "Australia/Sydney",
    offset: "GMT+10",
  },
  {
    name: "Pacific/Bougainville",
    offset: "GMT+11",
  },
  {
    name: "Pacific/Kosrae",
    offset: "GMT+11",
  },
  {
    name: "Australia/Lord_Howe",
    offset: "GMT+10.5",
  },
  {
    name: "Pacific/Noumea",
    offset: "GMT+11",
  },
  {
    name: "Asia/Sakhalin",
    offset: "GMT+11",
  },
  {
    name: "Pacific/Guadalcanal",
    offset: "GMT+11",
  },
  {
    name: "Pacific/Efate",
    offset: "GMT+11",
  },
  {
    name: "Pacific/Fiji",
    offset: "GMT+12",
  },
  {
    name: "Pacific/Tarawa",
    offset: "GMT+12",
  },
  {
    name: "Pacific/Majuro",
    offset: "GMT+12",
  },
  {
    name: "Pacific/Nauru",
    offset: "GMT+12",
  },
  {
    name: "Pacific/Norfolk",
    offset: "GMT+11",
  },
  {
    name: "Asia/Kamchatka",
    offset: "GMT+12",
  },
  {
    name: "Pacific/Funafuti",
    offset: "GMT+12",
  },
  {
    name: "Pacific/Wake",
    offset: "GMT+12",
  },
  {
    name: "Pacific/Wallis",
    offset: "GMT+12",
  },
  {
    name: "Pacific/Auckland",
    offset: "GMT+12",
  },
  {
    name: "Antarctica/McMurdo",
    offset: "GMT+12",
  },
  {
    name: "Pacific/Enderbury",
    offset: "GMT+13",
  },
  {
    name: "Pacific/Fakaofo",
    offset: "GMT+13",
  },
  {
    name: "Pacific/Tongatapu",
    offset: "GMT+13",
  },
  {
    name: "Pacific/Chatham",
    offset: "GMT+12.75",
  },
  {
    name: "Pacific/Apia",
    offset: "GMT+13",
  },
  {
    name: "Pacific/Kiritimati",
    offset: "GMT+14",
  },
];
